import { isPlatformBrowser } from '@angular/common';
import { Injectable, PLATFORM_ID, inject } from '@angular/core';
import { TwclidService } from '../twclid.service';
import { DataLayerService } from '../data-layer/data-layer.service';
import { GoogleEventTypes } from '../../enum/datalayer-event-types';
import { StateService } from '../storage/state.service';
declare let dataLayer: any[];
@Injectable({
  providedIn: 'root'
})
export class XGTMService {
  private twclidService = inject(TwclidService);
  private dataLayerService = inject(DataLayerService);

  productId: string | null = null;
  xAdsData: { twclid: string | null; productId: string | null } | null = null;
  platformId = inject(PLATFORM_ID);
  constructor() {
  }

  initPushEvent(
    eventName: GoogleEventTypes,
    eventParams: Record<string, any> = {}
  ) {
    if (!isPlatformBrowser(this.platformId)) return;

    if (this.xAdsData?.twclid) {
      this.pushEvent(eventName, eventParams);
    } else {
      const twclid = this.twclidService.xAdsData$.subscribe((data) => {
        this.xAdsData = data;
        if (this.xAdsData?.twclid) {
          this.pushEvent(eventName, eventParams);
        }
      });
    }
  }

  pushEvent(
    eventName: GoogleEventTypes,
    eventParams: Record<string, any> = {}
  ) {
    if (
      (eventName === 'purchase' &&
        this.xAdsData.productId !== null &&
        this.productId !== this.xAdsData?.productId) ||
      !this.xAdsData?.twclid
    )
      return;

    // dataLayer = window.dataLayer || [];
    this.dataLayerService.pushGoogleEvent(eventName, {
      ...eventParams,
      ...(this.xAdsData?.twclid ? { twclid: this.xAdsData?.twclid } : {})
    });
  }

  trackPurchase(
    productId: string,
    name: string,
    productPrice: number,
    email_address: string,
    price: number,
    currency: string = 'USD'
  ) {
    this.productId = productId;
    this.initPushEvent(GoogleEventTypes.PURCHASE, {
      email_address: email_address,
      contents: [
        {
          content_Id: productId,
          content_name: name,
          content_price: productPrice
        }
      ],
      content_type: 'product',
      currency: currency,
      value: price
    });
  }

  trackAddToCart(
    productId: string,
    name: string,
    price: number,
    currency: string,
    email_address?: string
  ) {
    this.initPushEvent(GoogleEventTypes.ADD_TO_CART, {
      email_address: email_address,
      contents: [{ content_Id: productId, content_name: name }],
      value: price,
      currency: currency
    });
  }

  trackSearch(searchTerm: string) {
    this.initPushEvent(GoogleEventTypes.SEARCH, {
      search_string: searchTerm
    });
  }
}
